function T5TableLess30SearchResult({ data }) {

    //console.log("TableDataBootstrap, data, isFetching", data);

    const columns = [
        { header: 'Nro', key: 'index', width: 23, visible: true },
        { header: 'Id', key: 'id', id: 23, visible: true },
         { header: 'Texto buscado', key: 'text_search', width: 23, visible: true },
         { header: 'Total de Items', key: 'total_items', width: 23, visible: true },
        { header: 'Ids Encontrados', key: 'search_results_ids', width: 23, visible: true },
        { header: 'Filtros', key: 'filter_results', width: 23, visible: true },
    
    ];

    return (
        <div>
            <div className="text-start">
                <strong>Tabla: SearchResult, Resultado de Busqueda menores a 30 por módulo:</strong>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className=''>
                            {data && data.length > 0 && columns && columns.length > 0 && (
                                columns.map((item, index) => {
                                    return (
                                        <th className=''>{item.header}</th>
                                    )
                                })
                            )}
                        </tr>
                    </thead>
                    <tbody>

                        {/* Start Table Body Columns */}
                        {data && data.length > 0 && (
                            data.map((item, index) => {
                                return (
                                    <tr key={index} className=''>

                                        <td className="list-table-cell-50"> {index+1} </td>
                                        <td className="list-table-cell-50"> {item.id} </td>
                                         <td className="list-table-cell-100"> {item.text_search} </td>
                                         <td className="list-table-cell-50"> {item.total_items} </td>
                                        <td className="list-table-cell-100"> {item.search_results_ids} </td>
                                        <td className="list-table-cell-500"> <pre> { JSON.stringify(item.filter_results, null, 2) } </pre></td>
                                    </tr>
                                )
                            })
                        )}
                        {/* End Table Body Columns */}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default T5TableLess30SearchResult